import validateFromAndToAddresses from './fromAndToAddresses';
import validateEtdAndEta from './etdAndEta';
import validateAtdAndAta from './atdAndAta';
import validateDriversInLeg from './drivers';

export default function validateLegs(legs, { validateDrivers, allowEqualAddresses }) {
	let legsErrors = legs.map(leg => validateLeg(leg, { validateDrivers, allowEqualAddresses }));
	let isInvalid = legsErrors.reduce((acc, legErrors) => acc || legErrors.isInvalid, false);
	return { legs: legsErrors, isInvalid };
}

function validateLeg(leg, { validateDrivers, allowEqualAddresses }) {
	let errors = {
		...validateFromAndToAddresses(leg, allowEqualAddresses),
		...validateEtdAndEta(leg),
		...validateAtdAndAta(leg),
	};
	if (validateDrivers) {
		let { driver, broadcastDrivers, isInvalid } = validateDriversInLeg(leg);
		errors = { ...errors, driver, broadcastDrivers, driversIsInvalid: isInvalid };
	}
	errors.isInvalid = Object.values(errors).reduce((acc, v) => acc || Boolean(v), false);
	return errors;
}